function RHTextShape(container, width, height, initialText) {
    width = width || 1000;
    height = height || 800;
    initialText = initialText || "Sample";

    // create container element if not exist
    if (document.getElementById(container) === null) {
        var containerTag = document.createElement("div");
        containerTag.setAttribute("id", container);
        document.body.appendChild(containerTag);
    }

    this.draw = SVG(container).size(width, height);
    this.text = this.draw.text(initialText);

    this.baseShape = null;
    this.outline2Shape = null;
    this.shadowShape = null;

    this.initTextOutlineAndShadow();

    this.currentTextWidth = this.text.bbox().width;

    this.setShape(RHTextShape.SHAPE_NONE);
}

RHTextShape.SHAPE_NONE = "none";
RHTextShape.SHAPE_ARC = "arc";
RHTextShape.SHAPE_VERTICAL_ARC = "vertical arc";

RHTextShape.DEFAULT_FONT_SIZE = 120;
RHTextShape.DEFAULT_SHADOW_GAP_X = 2;
RHTextShape.DEFAULT_SHADOW_GAP_Y = RHTextShape.DEFAULT_SHADOW_GAP_X * 6;
RHTextShape.DEFAULT_OUTLINE_WIDTH = 4;

RHTextShape.prototype = {
    initTextOutlineAndShadow: function() {
        this.text.font({
            fill: "transparent",
            size: RHTextShape.DEFAULT_FONT_SIZE
        });
        this.text.style({
            'user-select': "none"
        });
        this.text.move(0, 0);

        // this.textOutline1 - no need to create object for outline 1, stroke attribute is built in in svg
        this.textOutline2 = this.text.clone();
        this.textShadow = this.text.clone();

        this.text.node.classList.add('base-text');
        this.textOutline2.node.classList.add('outline2');
        this.textShadow.node.classList.add('text-shadow');

        this.textOutline2.move(0, 0);
        this.textShadow.move(RHTextShape.DEFAULT_SHADOW_GAP_X, RHTextShape.DEFAULT_SHADOW_GAP_Y);

        // group the text layers
        // NOTE: Hierarchy is important
        this.textGroup = this.draw.group();
        this.textGroup.add(this.textShadow);
        this.textGroup.add(this.textOutline2);
        this.textGroup.add(this.text);
    },

    setShape: function(shape, callback) {
        // call returnToOriginalText before set to new shape
        if (this.baseShape !== null) {
            this.baseShape.returnToOriginalText();
            this.outline2Shape.returnToOriginalText();
            this.shadowShape.returnToOriginalText();
        }

        switch (shape) {
            case RHTextShape.SHAPE_NONE:
                this.baseShape = new NoneShape(this.draw, this.text);
                this.outline2Shape = new NoneShape(this.draw, this.textOutline2);
                this.shadowShape = new NoneShape(this.draw, this.textShadow);
                this.moveToCenter(callback);

                break;

            case RHTextShape.SHAPE_ARC:
                this.baseShape = new ArcShape(this.draw, this.text);
                this.outline2Shape = new ArcShape(this.draw, this.textOutline2);
                this.shadowShape = new ArcShape(this.draw, this.textShadow);

                this.baseShape.hideTool();
                this.outline2Shape.hideTool();
                this.shadowShape.hideTool();
                this.moveToCenter(callback);

                break;

            case RHTextShape.SHAPE_VERTICAL_ARC:

                break;
        }
    },

    changeBaseColor: function(color) {
        this.baseShape.changeColor(color);
    },

    changeOutline1Color: function(color) {
        this.baseShape.changeStrokeColor(color);
    },

    changeOutline1Width: function(width) {
        width = width || RHTextShape.DEFAULT_OUTLINE_WIDTH;
        this.baseShape.changeStrokeWidth(width);
    },

    removeOutline1: function() {
        this.baseShape.removeOutline();
    },

    changeOutline2Color: function(color) {
        this.outline2Shape.changeColor(color);
        this.outline2Shape.changeStrokeColor(color);
    },

    updateOutline2Width: function() {
        var width = this.baseShape.text.data('stroke-width') > 0 ? this.baseShape.text.data('stroke-width') : 0;
        this.outline2Shape.changeStrokeWidth(width * 4);
    },

    removeOutline2: function() {
        this.outline2Shape.changeColor("transparent");
        this.outline2Shape.changeStrokeColor("transparent");
        this.outline2Shape.changeStrokeWidth(0);
    },

    changeShadowColor: function(color) {
        this.shadowShape.changeColor(color);
        this.shadowShape.changeStrokeColor(color);
        // this.textShadow.font('fill', color);
        // this.textShadow.font('stroke', color);
    },

    changeText: function(text, callback) {
        this.baseShape.changeText(text);
        this.outline2Shape.changeText(text);
        this.shadowShape.changeText(text);
        this.moveToCenter(callback);
    },

    changeFontSize: function(size, callback) {
        if (this.baseShape.text.attr("font-size") !== size) {
            this.baseShape.changeFontSize(size);
        }

        if (this.outline2Shape.text.attr("font-size") !== size) {
            this.outline2Shape.changeFontSize(size);
        }

        if (this.shadowShape.text.attr("font-size") !== size) {
            this.shadowShape.changeFontSize(size);
        }

        this.moveToCenter(callback);
    },

    changeFontFamily: function(family, callback) {
        if (this.baseShape.text.attr("font-family") !== family) {
            this.baseShape.changeFontFamily(family);
        }

        if (this.outline2Shape.text.attr("font-family") !== family) {
            this.outline2Shape.changeFontFamily(family);
        }

        if (this.shadowShape.text.attr("font-family") !== family) {
            this.shadowShape.changeFontFamily(family);
        }

        this.moveToCenter(callback);
    },

    removeShadow: function() {
        this.shadowShape.changeColor("transparent");
        this.shadowShape.changeColor("transparent");
        this.shadowShape.changeStrokeColor("transparent");
        this.shadowShape.changeStrokeWidth(0);
    },

    reLocateTextShadow: function() {
        var NOT_USED_BASIS = "transparent";

        if (this.shadowShape.text.attr("fill") !== NOT_USED_BASIS) {
            var textStrokeWidth = this.baseShape.text.attr("stroke-width");
            var textOutline2StrokeWidth = this.outline2Shape.text.attr("stroke-width");

            if (textOutline2StrokeWidth > 0) {
                this.shadowShape.changeStrokeWidth(textOutline2StrokeWidth);
            } else if (textStrokeWidth > 0) {
                this.shadowShape.changeStrokeWidth(textStrokeWidth);
            }
        }
    },

    moveToCenter: function(callback) {
        var _this = this;

        switch (true) {
            case this.baseShape instanceof NoneShape:
                this.canNowProceed(function() {
                    _this.baseShape.moveToCenter();
                    _this.outline2Shape.moveToCenter();
                    _this.shadowShape.moveToCenter(RHTextShape.DEFAULT_SHADOW_GAP_X, RHTextShape.DEFAULT_SHADOW_GAP_Y);
                    _this.reLocateTextShadow();

                    if (typeof callback === "function") {
                        callback();
                    }
                });

                break;

            case this.baseShape instanceof ArcShape:
                this.canNowProceed(function() {
                    _this.baseShape.updatePosition();
                    _this.baseShape.moveToCenter();

                    _this.outline2Shape.updatePosition();
                    _this.outline2Shape.moveToCenter();

                    _this.shadowShape.updatePosition();
                    _this.shadowShape.moveToCenter(RHTextShape.DEFAULT_SHADOW_GAP_X, RHTextShape.DEFAULT_SHADOW_GAP_Y);

                    if (typeof callback === "function") {
                        callback();
                    }
                });
                break;
        }
    },

    canNowProceed: function(callback) {
        var _this = this;
        var currentWidth = this.currentTextWidth;

        var tries = 20;

        var beforeProceedTime = setInterval(function() {
            var updatedTextWidth = _this.baseShape.text.bbox().width;

            if (tries > 0) {
                if (currentWidth !== updatedTextWidth) {
                    _this.currentTextWidth = updatedTextWidth;

                    clearInterval(beforeProceedTime);
                    if (typeof callback === "function") {
                        callback();
                    }
                }
            } else {
                clearInterval(beforeProceedTime);
                if (typeof callback === "function") {
                    callback();
                }
            }

            tries--;
        }, 500);
    }
};